import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
interface LightningProps {
  className?: string;
  /** Average seconds between strikes */
  interval?: number;
}
function randomPath(side: 'left' | 'right' | 'center') {
  const startX = side === 'left' ? 5 : side === 'right' ? 95 : 30 + Math.random() * 40;
  let d = `M ${startX} 0`;
  let x = startX;
  const segments = 8;
  for (let i = 1; i <= segments; i++) {
    x += (Math.random() - 0.5) * 10;
    const y = 100 / segments * i;
    d += ` L ${x} ${y}`;
  }
  return d;
}
export function Lightning({
  className = '',
  interval = 4
}: LightningProps) {
  const [strikes, setStrikes] = useState<Array<{
    id: number;
    d: string;
  }>>([]);
  useEffect(() => {
    let id = 0;
    const trigger = () => {
      const sides: ('left' | 'right' | 'center')[] = ['left', 'right', 'center'];
      const side = sides[Math.floor(Math.random() * sides.length)];
      id++;
      const strikeId = id;
      setStrikes(prev => [...prev, {
        id: strikeId,
        d: randomPath(side)
      }]);
      setTimeout(() => {
        setStrikes(prev => prev.filter(s => s.id !== strikeId));
      }, 600);
    };
    const i = setInterval(trigger, interval * 1000 * (0.7 + Math.random() * 0.6));
    return () => clearInterval(i);
  }, [interval]);
  return <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`} data-id="element-223">
      <svg className="absolute inset-0 w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none" data-id="element-224">
        <AnimatePresence data-id="element-225">
          {strikes.map(s => <motion.path key={s.id} d={s.d} fill="none" stroke="#1a8fd4" strokeWidth="0.3" strokeLinecap="round" initial={{
          opacity: 0
        }} animate={{
          opacity: [0, 1, 0.6, 1, 0]
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.6
        }} style={{
          filter: 'drop-shadow(0 0 4px #1a8fd4) drop-shadow(0 0 12px rgba(26,143,212,0.7))'
        }} data-id="element-226" />)}
        </AnimatePresence>
      </svg>
    </div>;
}